import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import pavithra from './../../../../assets/images/Doctorsimages/dr.pavithra.png'
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const PavithraDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. Pavithrakamatchi S | Best Aesthetic, Clinical Cosmetology & Homeopathy Doctor in Tambaram, Chennai";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Pavithrakamatchi S (BHMS, PDFAC), Consultant in Facial Aesthetics, Clinical Cosmetology & Homeopathy at H-Cura, Tambaram Chennai. Expert in homeopathy, facial aesthetics, cosmetology, yoga, acupuncture, naturopathy & psychology for chronic diseases, stress, skin, and lifestyle disorders."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best Aesthetic & homeopathy doctor in Tambaram Chennai, female Aesthetic & homeopathy doctor in Chennai, holistic doctor in Tambaram Chennai, facial aesthetics doctor Chennai, clinical cosmetology specialist Chennai, yoga and naturopathy doctor in Chennai, acupuncture specialist in Chennai, Aesthetic & homeopathy doctor for anxiety in Chennai, best doctor for chronic diseases in Tambaram, holistic medicine consultant in Chennai, female holistic doctor in Tambaram, natural healing doctor near me Chennai, Aesthetic & homeopathy specialist in Tambaram Chennai, homeopathy clinic in Tambaram Chennai"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-pavithrakamatchi-tambaram-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-pavithrakamatchi-tambaram-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

     

     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }
      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const marginLeft = 10; 
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Pavithra_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};
  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Pavithrakamatchi S</span>
                  <span className="veenadoc-title-credentials">(BHMS ,PDFAC)</span>
                  <span className="veenadoc-title-location">Tambaram, Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Compassionate Aesthetic & homeopathy doctor at H-Cura Multispeciality Clinic, Tambaram, Chennai. 
                    She blends expertise in homeopathy, yoga, naturopathy, acupuncture, and psychology to provide natural, 
                    safe, and long-term healing solutions for patients seeking integrated healthcare.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={pavithra} alt="Dr. Pavithrakamatchi S – Aesthetic & Homeopathy Doctor in Tambaram, Chennai" className="veenadoc-doctor-image" title='Dr. Pavithrakamatchi S | Best Female Aesthetic & Homeopathy Doctor in Tambaram Chennai' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Pavithrakamatchi S</h2>
                  <p>
                    Dr. Pavithrakamatchi S is a compassionate and dedicated Aesthetic & homeopathy doctor in Tambaram, Chennai, 
                    currently practicing as a Consultant at H-Cura Multispeciality Clinic. She blends her expertise in homeopathy, 
                    yoga, naturopathy, acupuncture, and psychology to provide natural, safe, and long-term healing solutions for patients.
                  </p>
                  <p>
                    With her integrative approach, she has become one of the most trusted doctors for those searching for the best Aesthetic &
                    homeopathy doctor in Tambaram Chennai, a female Aesthetic & homeopathy doctor in Chennai, or a holistic medicine consultant 
                    near Chromepet, Pallavaram, Medavakkam, Perungalathur, Selaiyur, and Vandalur.
                  </p>
                </div>

                {/* Educational Background */}
                <div className="veenadoc-article-block">
                  <h2>Educational Excellence & Holistic Training</h2>
                  <p>
                    Dr. Pavithrakamatchi holds a BHMS degree from Sarada Krishna Homoeopathic Medical College, Kanyakumari under 
                    Dr. M.G.R Medical University. She has further specialized with a Post Graduate Diploma in Facial Aesthetics & Clinical Cosmetology (PDFAC) from ILACAD Institute. To expand her healing skills, she also completed a Diploma in Yoga, is pursuing 
                    an Advanced Diploma in Acupuncture and Naturopathy, and has enrolled in an MSc in Psychology.
                  </p>
                  <p>
                    This unique educational background allows her to integrate Facial Aesthetics, Clinical Cosmetology, Homeopathy and other holistic practices, helping 
                    patients achieve balance of mind, body, and spirit. Her early clinical experience in Kanyakumari gave her a 
                    strong foundation in treating chronic diseases and lifestyle disorders.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS,PDFAC, Yoga, Acupuncture, Psychology</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Holistic Medicine & Homeopathy</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">H-Cura Tambaram, Chennai</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Areas Served:</span>
                      <span className="veenadoc-info-value">Chromepet, Pallavaram, Medavakkam</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Pavithra has gained recognition as a trichology doctor in Chennai specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>
                
                {/* Treatment Conditions */}
                <div className="veenadoc-article-block">
                  <h2>Comprehensive Treatment Expertise</h2>
                  <p>
                    After moving to Chennai, she started consulting at H-Cura Tambaram, where she has quickly built a reputation 
                    as one of the best holistic doctors in Tambaram Chennai. Today, she provides care to patients from nearby areas 
                    including Chromepet, Pallavaram, Medavakkam, Perungalathur, Selaiyur, Vandalur, and Velachery.
                  </p>
                  <p>
                    Patients consult her for a wide range of conditions such as skin disorders (acne, pigmentation, eczema, psoriasis, 
                    vitiligo), hair problems (hair fall, dandruff, thinning, alopecia), women's health issues (PCOS/PCOD, infertility, 
                    menstrual irregularities, menopause care), chronic diseases (arthritis, thyroid disorders, diabetes-related 
                    complications, migraines), respiratory conditions (asthma, bronchitis, chronic cough, allergies), and mental health 
                    & lifestyle issues (stress, anxiety, sleep disorders, depression management).
                  </p>
                </div>

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block">
                  <h2>Patient-Centric Treatment Philosophy</h2>
                  <p>
                    Her treatment philosophy is deeply patient-centric. She often says: "Treating diseases is not a big deal, treating 
                    human matters." This reflects her belief that true healing is not only about relieving symptoms but about understanding 
                    the person as a whole.
                  </p>
                  <p>
                    During consultations, she listens carefully to her patients' concerns, studies their medical history, emotional state, 
                    and lifestyle before designing a treatment plan. This empathetic and personalized approach makes her one of the most 
                    recommended female Aesthetic & homeopathy doctors in Chennai.
                  </p>
                </div>

                {/* Five Holistic Branches */}
                <div className="veenadoc-article-block">
                  <h2>Five Branches of Holistic Healing Integration</h2>
                  <p>
                    At H-Cura Tambaram Clinic, she integrates five holistic branches of healing: Homeopathy for safe, natural remedies 
                    for chronic and acute conditions; Yoga to improve immunity, flexibility, and mental peace; Naturopathy for detox 
                    and lifestyle corrections for long-term wellness; Acupuncture for pain management, hormonal balance, and energy flow; 
                    and Psychology for emotional support, stress management, and behavioral health.
                  </p>
                  <p>
                    This unique combination makes her an excellent choice for those searching for a holistic doctor in Tambaram Chennai, 
                    an acupuncture specialist in Chennai, or a yoga and naturopathy doctor near Pallavaram or Medavakkam.
                  </p>
                </div>

                {/* Mental Health Support */}
                <div className="veenadoc-article-block">
                  <h2>Mental Health & Psychological Support</h2>
                  <p>
                    Her additional training in psychology gives her an edge in treating mental health-related concerns. In today's 
                    stressful lifestyle, many patients in Chennai search for a homeopathy doctor for anxiety, depression, or sleep 
                    disorders in Tambaram. Dr. Pavithrakamatchi provides holistic solutions that heal both the mind and body.
                  </p>
                  <p>
                    Patients from Perungalathur, Selaiyur, Vandalur, and Velachery frequently visit H-Cura Tambaram for her guidance 
                    in managing stress, migraines, hormonal imbalances, and chronic fatigue. Her integrated treatments not only provide 
                    relief but also teach patients preventive methods and lifestyle improvements to maintain long-term health.
                  </p>
                </div>

                {/* Women's Health */}
                <div className="veenadoc-article-block">
                  <h2>Specialized Women's Health & Fertility Care</h2>
                  <p>
                    Her expertise also extends to women's health and fertility care. Many women consult her for PCOS, infertility, 
                    and menstrual disorders, and she provides safe and effective treatments without side effects. Her holistic methods 
                    ensure that women not only see improvements in their reproductive health but also gain overall hormonal balance 
                    and emotional well-being.
                  </p>
                  <p>
                    Patients searching online for a female homeopathy doctor for PCOS in Tambaram Chennai, a homeopathy skin doctor 
                    near Medavakkam, or a holistic doctor for infertility near Chromepet often choose Dr. Pavithrakamatchi because 
                    of her ability to combine homeopathy with yoga therapy, naturopathy, acupuncture, and psychological guidance.
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Community Trust</h2>
                  <p>
                    Her approachable nature and ability to explain treatments clearly have earned her glowing reviews. Many patients 
                    describe her as kind, patient, and deeply understanding. Families looking for the best female homeopathy doctor 
                    in Tambaram Chennai or a natural healing doctor near Chromepet often recommend her to friends and relatives.
                  </p>
                  <p>
                    In Chennai, there is increasing demand for natural and non-invasive healthcare, and Dr. Pavithrakamatchi's practice 
                    at H-Cura Tambaram meets this demand perfectly. Patients searching for queries like "best homeopathy doctor in 
                    Tambaram Chennai for thyroid," "female holistic doctor in Pallavaram," or "naturopathy and acupuncture treatment 
                    near Medavakkam" find her profile highly relevant.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Pavithrakamatchi S for Integrated Holistic Care</h2>
                  <p>
                    For anyone seeking a female homeopathy doctor in Tambaram, a holistic doctor in Chennai, a skin and hair homeopathy 
                    specialist near Chromepet, a naturopathy and acupuncture doctor near Pallavaram, or a natural healing consultant 
                    in Medavakkam, Dr. Pavithrakamatchi S is a highly trusted choice.
                  </p>
                  <p>
                    By blending classical homeopathy with modern holistic approaches, she provides long-lasting results for chronic 
                    diseases and lifestyle-related problems. This integrated care model sets her apart as one of the top holistic 
                    doctors in Chennai.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide natural, safe, and holistic healing that transforms lives across Chennai 
                    through integrated medicine and compassionate care.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Treating diseases is not a big deal, treating human matters"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Pavithrakamatchi S's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing the root 
                    cause of illness. This patient-centric approach has positioned her among the best holistic homeopathy 
                    doctors in Chennai, where she provides customized treatments for individuals of all age groups.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Tambaram, Chennai</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                  {/* <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Serving Chromepet, Pallavaram, Medavakkam</h4>
                      <p>Extended care services</p>
                    </div>
                  </div> */}
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Pavithrakamatchi's integrated approach combining five branches of natural medicine.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+918870001377'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+918870001377'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default PavithraDoc
